import React, {type ReactNode} from 'react';
import {AccordionItemView} from './Accordion.styles';
import type {HTMLAttributes, SpringTooling} from '../__SharedTypes';

export type AccordionItemProps = {
  /**
   * Content for AccordionItem.
   */
  children?: ReactNode;
  isDisabled?: boolean;
} & HTMLAttributes &
  SpringTooling;

/**
 * @spring-must-be-inside Accordion
 * @spring-constraint-severity error
 */
export const AccordionItem = React.forwardRef<
  HTMLDivElement,
  AccordionItemProps
>(({...props}: AccordionItemProps, ref) => {
  return <AccordionItemView {...props} ref={ref} />;
});
AccordionItem.displayName = 'AccordionItem';
AccordionItem.toString = AccordionItemView.toString;

export default AccordionItem;

export const AccordionItemContext = React.createContext({
  index: -1,
});
